import { updatesData } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '新番上架': 'bg-accent-100 text-accent-700',
  '完结公告': 'bg-primary-100 text-primary-700',
  '功能更新': 'bg-secondary-100 text-secondary-700',
  '榜单揭晓': 'bg-accent-100 text-accent-700',
  '专题推荐': 'bg-primary-100 text-primary-700',
  '合作联动': 'bg-secondary-100 text-secondary-700',
  '活动预告': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-flashlight-line"></i>
            <span>实时更新</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            关注女神漫画最新资讯，新番上架、功能更新、活动预告一站掌握
          </p>
        </div>

        <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
          {updatesData.map((item, idx) => (
            <div key={idx} className="relative pb-10 last:pb-0">
              <div className="absolute -left-[29px] md:-left-[33px] w-4 h-4 rounded-full bg-primary-500 border-4 border-background-50"></div>
              <div className="bg-background-100 rounded-lg p-4 md:p-5 ml-1">
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}